import { render, staticRenderFns } from "./followRecord.vue?vue&type=template&id=027ea362&"
import script from "./followRecord.vue?vue&type=script&lang=js&"
export * from "./followRecord.vue?vue&type=script&lang=js&"
import style0 from "./followRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports